/**
 * Coque sombre pour le SPA notaire lorsque `merge_dark_public_shell_theme` est actif (thème public).
 * Alignement login / layouts deux colonnes avec le back-office DocV (Tailwind `globals.css` `.dark`).
 * Appliqué après le thème `GET …/public/site-config` pour écraser les neutres clairs de `theme_json` sur cette ligne uniquement.
 * Toasts, menu compte (ProfileModal) et panneau notifications (NotificationModal) via `--header-*` / `--toaster-*`.
 */
const NOTARY_PUBLIC_DARK_SHELL_THEME_CSS_VARS: Record<string, string> = {
	"--lecoffre-body-background": "#12192c",
	"--lecoffre-input-background": "#1c2538",
	"--menu-background": "#151e34",
	"--button-header-background": "var(--menu-background)",
	"--dropdown-menu-background": "var(--background-elevation-2)",
	"--menu-border": "#2a3754",
	"--separator-stroke-light": "#2a3754",
	"--footer-background": "#151e34",
	"--footer-border": "#2a3754",
	"--footer-contrast": "#aeb9ce",
	"--background-primary": "#12192c",
	"--background-elevation-1": "#161f35",
	"--background-elevation-2": "#1c2538",
	"--input-background": "#1c2538",
	"--dropdown-input-background": "#1c2538",
	"--text-primary": "#eceff4",
	"--text-secondary": "#9ca8bc",
	/* CTA primaires (ex. « Créer une opération » en bas de colonne liste) : le theme_json distant peut imposer un contraste sombre sur fond clair ; sur shell sombre le texte doit rester clair. */
	"--primary-default-contrast": "#eceff4",
	"--button-contained-primary-default-contrast": "#eceff4",
	"--button-contained-primary-hovered-contrast": "#eceff4",
	"--button-contained-primary-pressed-contrast": "#eceff4",
	"--color-neutral-25": "#0f141f",
	"--color-neutral-50": "#12192c",
	"--color-neutral-100": "#1a253a",
	"--color-neutral-200": "#243049",
	"--color-neutral-300": "#354162",
	"--color-neutral-400": "#5a6a85",
	"--color-neutral-500": "#7a8ba8",
	"--color-neutral-600": "#9ca8bc",
	"--color-neutral-700": "#b8c2d4",
	"--color-neutral-800": "#d8dee9",
	"--color-neutral-900": "#eceff4",
	"--color-neutral-950": "#f8f9fc",

	/* Toasts (react-toastify) — même élévation que les surfaces shell */
	"--toaster-background": "#1c2538",
	"--toaster-border": "#2a3754",
	"--toaster-radius": "8px",
	"--toaster-contrast-title": "#eceff4",
	"--toaster-contrast-text": "#9ca8bc",
	"--toaster-progress-bar": "#5b7fd1",
	"--toaster-shadow": "0 8px 28px rgba(0, 0, 0, 0.45)",

	/* Menu compte header + panneau notifications */
	"--header-account-menu-background": "#1c2538",
	"--header-account-menu-border": "#2a3754",
	"--header-account-menu-radius": "8px",
	"--header-account-menu-shadow": "0 8px 28px rgba(0, 0, 0, 0.45)",

	"--header-notification-panel-background": "#1c2538",
	"--header-notification-panel-border": "#2a3754",
	"--header-notification-panel-radius": "8px",
	"--header-notification-panel-shadow": "0 8px 28px rgba(0, 0, 0, 0.45)",
	"--notification-empty-state-background": "#243049",
	"--notification-unread-default": "#243049",
	"--notification-unread-hovered": "#354162",
};

export function getNotaryPublicDarkShellThemeCssVars(): Record<string, string> {
	return { ...NOTARY_PUBLIC_DARK_SHELL_THEME_CSS_VARS };
}
